/**
 * HM-414 cluster 17.2 polish: modal "Annulla prenotazione" admin-only,
 * aperto dal bottone Annulla del BookingDetailDrawer. Textarea motivo
 * obbligatoria (min 5 char). Submit chiama POST /bookings/:id/admin-cancel
 * (HM-411).
 */
import { useState } from 'react';
import type { PlanningItem } from '../../api/planning.js';

const REASON_MIN_LEN = 5;

export function CancelBookingModal({
  booking,
  pending,
  onSubmit,
  onCancel,
}: {
  booking: PlanningItem;
  pending: boolean;
  onSubmit: (reason: string) => void;
  onCancel: () => void;
}) {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();
  const isValid = trimmed.length >= REASON_MIN_LEN;
  const guestName = booking.guestName ?? `Walk-in ${booking.publicCode}`;

  return (
    <div
      className="planning-modal-overlay"
      // biome-ignore lint/a11y/useSemanticElements: pattern overlay div coerente con altri modal Planning Gantt.
      role="dialog"
      aria-modal="true"
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onCancel();
      }}
      data-testid="cancel-booking-modal"
    >
      <div className="planning-modal">
        <div className="planning-modal-title">Annulla prenotazione</div>
        <div className="planning-modal-body">
          <p>
            Stai per annullare la prenotazione di <strong>{guestName}</strong> (camera{' '}
            <strong>{booking.roomCode ?? '—'}</strong>). Il booking resta a storico, ma la camera
            torna libera.
          </p>
          <label
            htmlFor="cancel-reason"
            style={{
              display: 'block',
              fontSize: 12,
              color: '#7A6957',
              marginTop: 12,
              marginBottom: 4,
            }}
          >
            Motivo (almeno {REASON_MIN_LEN} caratteri)
          </label>
          <textarea
            id="cancel-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            data-testid="cancel-reason-input"
            rows={3}
            placeholder="es. cliente non si presenta, errore inserimento operatore, …"
            style={{
              width: '100%',
              padding: '8px 10px',
              borderRadius: 6,
              border: '1px solid #D4C4B0',
              resize: 'vertical',
              fontFamily: 'inherit',
              fontSize: 14,
            }}
            disabled={pending}
          />
          {reason.length > 0 && !isValid && (
            <p
              style={{ marginTop: 6, fontSize: 12, color: '#B85450' }}
              data-testid="cancel-reason-error"
            >
              Il motivo deve essere lungo almeno {REASON_MIN_LEN} caratteri.
            </p>
          )}
        </div>
        <div className="planning-modal-actions">
          <button
            type="button"
            className="planning-drawer-btn"
            onClick={onCancel}
            disabled={pending}
            data-testid="cancel-modal-cancel"
          >
            Indietro
          </button>
          <button
            type="button"
            className="planning-drawer-btn danger"
            onClick={() => onSubmit(trimmed)}
            disabled={!isValid || pending}
            data-testid="cancel-modal-submit"
          >
            {pending ? 'Annullo…' : 'Conferma annullamento'}
          </button>
        </div>
      </div>
    </div>
  );
}
